const {
  combine,
  required,
  isNumeric,
  isLength,
  custom,
  matches
} = require('./../../shared/lib/validation/schema');
const { isEmpty } = require('lodash');
const requiredMessage = 'This field is required';

export const schema = {
  name              : combine(required(), isLength(1, undefined, requiredMessage)),
  phoneNumber       : combine(required(), isLength(10, 10, 'Must be 10 digits'), isNumeric(), matches(/^[2-9]\d{9}$/, 'Must be a valid phone number.')),
  position          : combine(required(), isLength(1, undefined, requiredMessage)),
  yearsKnown        : combine(required(), isNumeric()),
  company           : combine(required(), isLength(1, undefined, requiredMessage)),
  relationshipId    : combine(required(), isLength(1, undefined, requiredMessage))
};

export function getSchema({referenceRelationshipTypes = []} = {}) {
  return {
    ...schema,
    relationshipOther : custom('relationshipOther', (reference, val) => {

      const otherRelationship = referenceRelationshipTypes.find(r => r.subElement === 'Other');
      const relationship = referenceRelationshipTypes.find(r => r.id === reference.relationshipId);
      if (relationship && relationship.id === otherRelationship.id) {
        return !isEmpty(val);
      }

      return true;

    }, requiredMessage)
  };
}



// WEBPACK FOOTER //
// ./shared/models/reference.js